import { useState } from "react";
import "../../../../../css/AML/Buttons/TertiaryButton.css";

const TertiaryButton = ({
  buttonText,
  isActive,
  onClick,
  disabled,
  showTooltip = false,
  children,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="tooltip-button-wrapper">
      <div
        className={`TertiaryButton ${isActive ? "clicked" : ""} ${
          disabled ? "disabled" : ""
        }`}
        onClick={onClick}
      >
        <div className="AML-Text-Input">{buttonText}</div>
      </div>
    </div>
  );
};

export default TertiaryButton;
